import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface TubeframeFormProps {
  enabled: boolean;
  tubeUnits: 'in' | 'mm';
  setTubeUnits: (v: 'in' | 'mm') => void;
  tubeOD: string;
  setTubeOD: (v: string) => void;
  tubeID: string;
  setTubeID: (v: string) => void;
  tubeJointAngle: string;
  setTubeJointAngle: (v: string) => void;
  tubeMatingSurface: string;
  setTubeMatingSurface: (v: string) => void;
}

export function TubeframeForm({
  enabled,
  tubeUnits,
  setTubeUnits,
  tubeOD,
  setTubeOD,
  tubeID,
  setTubeID,
  tubeJointAngle,
  setTubeJointAngle,
  tubeMatingSurface,
  setTubeMatingSurface,
}: TubeframeFormProps) {
  return (
    <div className="mt-4 grid w-full grid-cols-1 gap-y-3">
      {/* Units */}
      <div className="flex items-center">
        <span className="min-w-0 flex-1 pr-3 text-xs text-telekinesis-text-primary">
          Units
        </span>
        <div className="flex shrink-0 items-center gap-1.5">
          <Select
            disabled={!enabled}
            value={tubeUnits}
            onValueChange={(v) => setTubeUnits(v as 'in' | 'mm')}
          >
            <SelectTrigger className="h-7 w-36 rounded-md px-2 text-xs text-[#107d40]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="in">Inches</SelectItem>
              <SelectItem value="mm">Millimeters</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* O.D. */}
      <div className="flex items-center">
        <span className="min-w-0 flex-1 pr-3 text-xs text-telekinesis-text-primary">
          O.D.
        </span>
        <div className="flex shrink-0 items-center gap-1.5">
          <Input
            type="number"
            step="any"
            disabled={!enabled}
            value={tubeOD}
            onChange={(e) => setTubeOD(e.target.value)}
            className="h-7 w-20 rounded-md px-2 text-center text-xs text-[#107d40]"
          />
          <span className="w-16 text-right text-xs text-telekinesis-text-secondary">
            {tubeUnits === 'in' ? '[in.]' : '[mm]'}
          </span>
        </div>
      </div>

      {/* I.D. */}
      <div className="flex items-center">
        <span className="min-w-0 flex-1 pr-3 text-xs text-telekinesis-text-primary">
          I.D.
        </span>
        <div className="flex shrink-0 items-center gap-1.5">
          <Input
            type="number"
            step="any"
            disabled={!enabled}
            value={tubeID}
            onChange={(e) => setTubeID(e.target.value)}
            className="h-7 w-20 rounded-md px-2 text-center text-xs text-[#107d40]"
          />
          <span className="w-16 text-right text-xs text-telekinesis-text-secondary">
            {tubeUnits === 'in' ? '[in.]' : '[mm]'}
          </span>
        </div>
      </div>

      {/* Joint Angle */}
      <div className="flex items-center">
        <span className="min-w-0 flex-1 pr-3 text-xs text-telekinesis-text-primary">
          Joint Angle
        </span>
        <div className="flex shrink-0 items-center gap-1.5">
          <Input
            type="number"
            step="any"
            disabled={!enabled}
            value={tubeJointAngle}
            onChange={(e) => setTubeJointAngle(e.target.value)}
            className="h-7 w-20 rounded-md px-2 text-center text-xs text-[#107d40]"
          />
          <span className="w-16 text-right text-xs text-telekinesis-text-secondary">
            [°]
          </span>
        </div>
      </div>

      {/* Mating Surface */}
      <div className="flex items-center">
        <span className="min-w-0 flex-1 pr-3 text-xs text-telekinesis-text-primary">
          Mating Surface
        </span>
        <div className="flex shrink-0 items-center gap-1.5">
          <Select
            disabled={!enabled}
            value={tubeMatingSurface}
            onValueChange={setTubeMatingSurface}
          >
            <SelectTrigger className="h-7 w-36 rounded-md px-2 text-xs text-[#107d40]">
              <SelectValue placeholder="Select..." />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="straight-wall">Straight Wall</SelectItem>
              <SelectItem value="lattice">Lattice</SelectItem>
              <SelectItem value="threaded">Threaded</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
